import { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

type Props = {
  canRemove: boolean
  onRemove: () => void
}

const TeamSettings: FC<Props> = ({ canRemove, onRemove }) => {
  return (
    <Box gap="s16">
      <Button disabled={!canRemove} onClick={onRemove}>
        {i18n.t('people_chart.group_sidepanel.remove_from_chart')}
      </Button>
      <Callout
        type="info"
        title={i18n.t('people_chart.group_sidepanel.remove_team_from_chart')}
        description={i18n.t('people_chart.group_sidepanel.remove_from_chart_warning_message')}
      />
    </Box>
  )
}

export default TeamSettings
